import React from 'react';
import classnames from 'classnames';
var FormContainer = function(props) {
    var children = props.children;
    return /*#__PURE__*/ React.createElement("div", {
        className: "FormContainer"
    }, children);
};
var PrimaryHeader = function(props) {
    var children = props.children;
    return /*#__PURE__*/ React.createElement("div", {
        className: "PrimaryHeader"
    }, children);
};
var SecondaryHeader = function(props) {
    var children = props.children, isSecondary = props.isSecondary;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('SecondaryHeader', {
            secondary: isSecondary
        })
    }, children);
};
var FormContainerBody = function(props) {
    var children = props.children;
    return /*#__PURE__*/ React.createElement("div", {
        className: "FormContainerBody"
    }, children);
};
FormContainer.PrimaryHeader = PrimaryHeader;
FormContainer.SecondaryHeader = SecondaryHeader;
FormContainer.Body = FormContainerBody;
export default FormContainer;
